import { INFT } from '../../types/nft';
import { useEffect, useState } from 'react';

interface FilteredNFTs {
  setSearchText: (text: string) => void;
  filteredList: INFT[];
}

export const useFilteredNFTs = (initialList?: INFT[]): FilteredNFTs => {
  const [searchText, setSearchText] = useState('');
  const [filteredList, setFilteredList] = useState<INFT[]>([]);

  useEffect(() => {
    if (!initialList) {
      return;
    }
    const textToSearch = searchText.toLowerCase();

    const list1 = initialList.filter((nft) => nft.issuer?.toString().toLowerCase().startsWith(textToSearch));
    const list2 = initialList.filter((nft) => nft.name?.toString().toLowerCase().startsWith(textToSearch));
    setFilteredList(Array.from(new Set(list1.concat(list2))));
  }, [searchText, initialList]);

  return {
    setSearchText,
    filteredList,
  };
};
